export default __webpack_public_path__ + "static/media/Design_Minny.93a79495.jpg";